import React, { Component } from "react";
import UserService from "../services/user.service";
import Map from './maps';
import './leaflet.css';

import AuthService from "../services/auth.service";

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCheckSquare, faDoorClosed, faDoorOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(fab, faCheckSquare, faDoorClosed, faDoorOpen)

var lat="";
var lon="";

export default class Fichar extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);
    this.state = {
      content: "",
      curTime : new Date().toLocaleString(),
    };
    this.handleClick = this.handleClick.bind(this);

  }

  componentDidMount() {
    if ("geolocation" in navigator) {
      //console.log("Available");
      navigator.geolocation.getCurrentPosition(
        function(position) {
          console.log("Latitude is :", position.coords.latitude);
          console.log("Longitude is :", position.coords.longitude);
          lat=position.coords.latitude;
          lon=position.coords.longitude;
        },
        function(error) {
          console.error("Error Code = " + error.code + " - " + error.message);
        }
        );
    } else {
      console.log("Not Available");
    }


  }

  handleClick(e) {
    e.preventDefault();
    
    UserService.setEntrar(lat,lon).then(
      response => {
        console.log(response.status);
        if(response.status=='401'){
            this.logOut();
            window.location.href = `${process.env.PUBLIC_URL}/home`;
        }
        this.setState({
          content: response.data
        });
        window.location.href = `${process.env.PUBLIC_URL}/gracias`;
      },
      error => {
        this.setState({
          content:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString()
        });
      }
    );
      
  }

  logOut() {
    AuthService.logout();
  }


  render() {

    return (

        <div className="container">
            <div className="row">
                    <div className="col-md-3 top-comment-grid">
                        <div className="comments likes">
                            <a href="#" id="entrada" onClick={this.handleClick}>
                                <div className="comments-icon">
                                    <FontAwesomeIcon icon="door-open" size="6x" color="yellow"/>                                    
                                </div>
                                <div className="comments-info likes-info" style={{color: '#FFF'}}>
                                    <h3 style={{'fontSize': '2em','color': '#FFF'}}>Entrada</h3>
                                    {this.state.curTime}
                                </div>
                            </a>
                            <div className="clearfix"></div>
                        </div>
                    </div>

                    <div className="col-md-3 top-comment-grid">
                        <div className="comments likes">
                            <a href="#" id="salida" onClick={this.handleClick}>
                                <div className="comments-icon">
                                    <FontAwesomeIcon icon="door-closed" size="6x" color="red"/>                                    
                                </div>
                                <div className="comments-info likes-info" style={{color: '#FFF'}}>
                                    <h3 style={{'fontSize': '2em','color': '#FFF'}}>Salida</h3>
                                    {this.state.curTime}
                                </div>
                            </a>
                            <div className="clearfix"></div>
                        </div>
                        <div className="clearfix"></div>
                    </div>

        </div>

        <header className="jumbotron">
          <Map zoom={4} center={{ lat: 39.74739, lng: -105 }} />
        </header>

      </div>
    );
  }
}






